import axios from "axios";
import { ChatAPIs } from "../api/apiEndPoints";

export const getChats = () => axios.get(ChatAPIs.GET_CHATS);
export const getChat = (id) => axios.get(ChatAPIs.GET_CHAT(id));
